(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('tab-btn')) {
      const tabs = e.target.parentElement.querySelectorAll('.tab-btn');
      tabs.forEach(t => t.classList.remove('active'));
      e.target.classList.add('active');
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('reviewModal');
    const openBtn = document.getElementById('openReviewModal');
    const closeBtn = document.getElementById('closeModalBtn');
    const overlay = document.getElementById('closeModal');
    const cancelBtn = document.getElementById('cancelReview');
    const form = document.getElementById('reviewForm');
    
    if (openBtn && modal) {
      openBtn.addEventListener('click', function() {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('active');
      document.body.style.overflow = '';
      if (form) form.reset();
      document.querySelectorAll('.rating-star').forEach(s => {
        s.classList.remove('filled');
        s.textContent = '☆';
      });
      const rv = document.getElementById('ratingValue');
      if (rv) rv.value = 0;
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
    if (cancelBtn) cancelBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
        closeModal();
      }
    });

    const stars = document.querySelectorAll('.rating-star');
    const ratingInput = document.getElementById('ratingValue');
    
    stars.forEach(star => {
      star.addEventListener('click', function() {
        const value = parseInt(this.dataset.value);
        if (ratingInput) ratingInput.value = value;
        stars.forEach((s, index) => {
          if (index < value) {
            s.classList.add('filled');
            s.textContent = '★';
          } else {
            s.classList.remove('filled');
            s.textContent = '☆';
          }
        });
      });

      star.addEventListener('mouseenter', function() {
        const value = parseInt(this.dataset.value);
        stars.forEach((s, index) => {
          s.textContent = index < value ? '★' : '☆';
        });
      });
    });

    const ratingContainer = document.getElementById('starRating');
    if (ratingContainer && ratingInput) {
      ratingContainer.addEventListener('mouseleave', function() {
        const currentRating = parseInt(ratingInput.value) || 0;
        stars.forEach((s, index) => {
          s.textContent = index < currentRating ? '★' : '☆';
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const rating = ratingInput ? ratingInput.value : 0;
        if (rating == 0) {
          alert('Please select a rating');
          return;
        }
        alert('Thank you for your review! It will be published after moderation.');
        closeModal();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
